import { useMutation } from "@tanstack/react-query";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import API from "../../api/API";

const useUpdatePassword = () => {
  const updatePassword = useMutation({
    mutationFn: ({
      accountID,
      oldPassword,
      newPassword,
      onSuccess,
    }: {
      accountID: string;
      oldPassword: string;
      newPassword: string;
      onSuccess: () => void;
    }) =>
      API.updateAccountPassword(accountID, oldPassword, newPassword).then(
        () => {
          callFunctionIfExists(onSuccess);
        }
      ),
  });

  return {
    updatePassword: updatePassword.mutate,
    passwordUpdating: updatePassword.isPending,
    updatePasswordError: updatePassword.error
      ? getErrorMessage(updatePassword.error)
      : null,
  };
};

export default useUpdatePassword;
